import { Controller } from "@hotwired/stimulus"
import controller from "../utils/controller"

export default class extends Controller {
  static targets = ["modal", "kind", "residential", "commercial"]

  connect() {
    if (this.hasKindTarget) this.reflectKind()
  }

  reflectKind() {
    this.residentialTarget.classList.toggle("hidden", this.kind !== "residential")
    this.commercialTarget.classList.toggle("hidden", this.kind !== "commercial")
  }

  confirm(event) {
    event.preventDefault()

    this.confirmation.open()
  }

  get confirmation() {
    return controller(this.modalTarget, "modal")
  }

  get kind() {
    return this.kindTarget.value
  }
}
